import { TOrgTheme, getDevicePref } from '@eventr/common'
import { TColourSchemes, setColourScheme } from '@eventr/common-storybook'
import { deviceDetect } from 'react-device-detect'
import { create } from 'zustand'
import { getDevicePrefName } from '../../utils'

type TThemeState = {
    selectedColourScheme: TColourSchemes
    themeOverwrite: boolean
    customThemeId: string
    themeImages: any
    defaultTheme: any | null
    setScheme: (str: TColourSchemes, object?: any) => void
    setThemeImages: (obj: any) => void
    getScheme: () => TColourSchemes
    setOverride: (bool: boolean) => void
    getOverride: () => boolean
    setCustomId: (str: string) => void
    setDefaultTheme: (obj: TOrgTheme) => void
}

export const useThemeContext = create<TThemeState>()((set, get) => ({
    //sets device as default to be added back when dark mode is 100%
    themeOverwrite: getDevicePref('theme', getDevicePrefName(deviceDetect))
        ? true
        : false,
    // themeOverwrite: true,
    selectedColourScheme:
        getDevicePref('theme', getDevicePrefName(deviceDetect)) ?? 'light',

    customThemeId: '',
    themeImages:
        getDevicePref('themePalette', getDevicePrefName(deviceDetect))
            ?.images ?? {},
    defaultTheme: null,
    getScheme: () => {
        return get().selectedColourScheme
    },
    setScheme: (str: TColourSchemes, object?: TOrgTheme, customId?: string) => {
        set(() => ({
            selectedColourScheme: str,
        }))
        setColourScheme(str, object?.palette)
    },
    getOverride: () => {
        return get().themeOverwrite
    },
    setOverride: (bool: boolean) => {
        set(() => ({
            themeOverwrite: bool,
        }))
    },
    setCustomId: (str: string) => {
        set(() => ({
            customThemeId: str,
        }))
    },
    setThemeImages: (obj: any) => {
        set(() => ({
            themeImages: obj,
        }))
    },
    setDefaultTheme: (obj: TOrgTheme) => {
        set(() => ({
            defaultTheme: obj,
        }))
    },
}))
